/*! @azure/msal-common v16.6.2 2026-05-19 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.6.2";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
